/**
 *
 * @param {FormData} data
 * @returns
 */
export default function getOrderFormMarkupWithData(data) {
    return BX.ajax.runComponentAction('opensource:order', 'executeComponent', {
        mode: 'class',
        data,
        method: 'POST',
    });
}
